define('gameday-index-enums/enums/events/OauthEvents',{
	isLogin: "GameDayIndex::isLogin",
	isLoginNoEntitlement: "GameDayIndex::sLoginNoEntitlement",
	isNotLogin: "GameDayIndex::isNotLogin",
	checkOauthStatus: "GameDayIndex::checkOauthStatus",
	userIsNotLogin : "GameDayIndex::userIsNotLogin",
	userIsLoginUpsell: "GameDayIndex::userIsLoginUpsell",
	userIsLogin: "GameDayIndex::userIsLogin",
	loginHide: "GameDayIndex::loginHide",

	MEDIA_CATALOG_SUCCESS: "MediaGateway_MEDIA_CATALOG_SUCCESS",
	MEDIA_CATALOG_ERROR: "MediaGateway_MEDIA_CATALOG_ERROR",
	MEDIA_CATALOG_NOT_AUTHORIZED: "MediaGateway_MEDIA_CATALOG_NOT_AUTHORIZED",
	
	MEDIA_ITEM_PLAYABLE: "MediaGateway_MEDIA_ITEM_PLAYABLE",
	MEDIA_ITEM_ERROR: "MediaGateway_MEDIA_ITEM_ERROR",
	MEDIA_ITEM_BLACKOUT: "MediaGateway_MEDIA_ITEM_BLACKOUT",
	MEDIA_ITEM_NOT_AUTHORIZED: "MediaGateway_MEDIA_ITEM_NOT_AUTHORIZED"
});

